const CodeOn = () => (
  <>
    <path
      fill="currentColor"
      d="m4.113 12.006 4.24 4.24a.5.5 0 0 1 .15.345.47.47 0 0 1-.15.363.5.5 0 0 1-.353.16.5.5 0 0 1-.354-.16l-4.388-4.389a.8.8 0 0 1-.184-.267.8.8 0 0 1-.053-.298.8.8 0 0 1 .053-.298.8.8 0 0 1 .184-.268l4.388-4.388a.5.5 0 0 1 .347-.156.47.47 0 0 1 .366.156q.165.166.166.357a.5.5 0 0 1-.166.356zm15.774-.012-4.24-4.24a.5.5 0 0 1-.15-.345.47.47 0 0 1 .15-.363.5.5 0 0 1 .353-.16.5.5 0 0 1 .354.16l4.388 4.389a.8.8 0 0 1 .184.267.8.8 0 0 1 .053.298.8.8 0 0 1-.053.298.8.8 0 0 1-.184.268l-4.388 4.388a.48.48 0 0 1-.707-.006.5.5 0 0 1-.166-.357q0-.19.165-.357z"
    />
  </>
)
export default CodeOn
